import React from 'react';
import { FaArrowAltCircleUp } from 'react-icons/fa';
import styles from './Arrow.module.css';

const onClickHandler = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const Arrow = () => {
  return (
    <button className={styles.container} onClick={onClickHandler}>
      <FaArrowAltCircleUp className={styles.icon} />
    </button>
  );
};

export default Arrow;
